<template>
  <v-text-field
    v-bind="$attrs"
    v-on="$listeners"
    class="ma-0"
    clearable
  ></v-text-field>
</template>

<script>
export default {
  name: 'AppInput'
};
</script>
